import { useTranslation } from "react-i18next";
import { getPromotionLabels } from "./promotionLabels";
import { Promotion } from "@quest_editor/mocks";

/**
 * 案件のオプション表示文字列を構築する
 */
export const getBuildOptionsDisplay = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation("questEditor");
  const { getProfileLabel, getTemplateScopeLabel } = getPromotionLabels();

  const buildOptionsDisplay = (
    promotion: Promotion | null | undefined,
  ): string[] => {
    if (!promotion) return [];
    const options: string[] = [];

    if (promotion.options.dataCheck) {
      options.push(
        promotion.options.dataCheckPriority
          ? t("common.options_display.data_check_priority")
          : t("common.options_display.data_check"),
      );
    }

    if (promotion.options.profiles.length > 0) {
      const profileLabels = promotion.options.profiles
        .map(getProfileLabel)
        .join("、");
      options.push(
        t("common.options_display.profiles", { profiles: profileLabels }),
      );
    }

    if (promotion.options.template && promotion.options.templateScope) {
      options.push(
        t("common.options_display.template", {
          scope: getTemplateScopeLabel(promotion.options.templateScope),
        }),
      );
    }

    return options;
  };

  return { buildOptionsDisplay };
};
